import {Component, isDevMode, OnDestroy, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";
import {Event, Router, NavigationStart, NavigationEnd} from '@angular/router';
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {IpService} from "./services/ip.service";
import {Analytics} from "@angular/fire/analytics";
import {AuthService, UserData} from "./auth.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {FullChild} from "./interfaces/FullChild";
import {Centre} from "./interfaces/Centres";
import firebase from "firebase/compat/app";
import {Donor} from "./components/donoradmin/donor-table/donor-table.component";
import {filter, map, switchMap, takeUntil} from "rxjs/operators";
import {environment} from "../environments/environment";
import {EmailService} from "./modules/shared/email.service";
import {MessagingService} from "./services/messaging.service";
import {UtilService} from "./services/util.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Subject} from "rxjs";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  currentUrl: string = '';
  ipAddress: string = '';
  customerName: string = 'fsf';
  env = isDevMode() ? environment.testMode : environment.productionMode
  /** Shows the Flutter-style DEV corner ribbon; dev mode uses the environment.testMode collections */
  readonly isDevMode = isDevMode()
  private wasOffline: boolean = false;
  private _destroyed$ = new Subject<void>();

  private offlineSnackRef: any = null;


  constructor(
    private title: Title,
    private router: Router,
    private mAuth: AngularFireAuth,
    private mDatabase: AngularFireDatabase,
    private mAuthService: AuthService,
    private readonly mailService: EmailService,
    private readonly mFirestore: AngularFirestore,
    private ipService: IpService,
    private networkService: UtilService,
    private snackBar: MatSnackBar
  ) {
    title.setTitle(isDevMode() ? 'Development' : 'Accesslife');
    this.setupRouterEvents();
    // this.sendDummyEmail()

    // this.networkService.onlineStatus$.subscribe((isOnline) => {
    //   console.log('Network status:', isOnline ? 'ONLINE ✅' : 'OFFLINE ❌');
    //
    //   if (!isOnline) {
    //     // Went offline
    //     this.wasOffline = true; // mark offline
    //     this.snackBar.open('Network is disconnected', 'Dismiss', {
    //       duration: 5000,
    //       panelClass: ['snackbar-error'],
    //       verticalPosition: 'top',
    //       horizontalPosition: 'center',
    //     });
    //   } else if (this.wasOffline) {
    //     // Only show "Back Online" if previously offline
    //     this.snackBar.open('Back Online', 'OK', {
    //       duration: 3000,
    //       panelClass: ['snackbar-success'],
    //       verticalPosition: 'top',
    //       horizontalPosition: 'center',
    //     });
    //     this.wasOffline = false; // reset flag
    //   }
    // });

    this.networkService.onlineStatus$.pipe(takeUntil(this._destroyed$)).subscribe((isOnline) => {
      console.log('Network status:', isOnline ? 'ONLINE ✅' : 'OFFLINE ❌');

      if (!isOnline) {
        this.wasOffline = true;

        // show snackbar ONLY ONCE
        if (!this.offlineSnackRef) {
          this.offlineSnackRef = this.snackBar.open(
            'Network is disconnected',
            undefined, // no close button
            {
              panelClass: ['snackbar-error'],
              verticalPosition: 'top',
              horizontalPosition: 'center'
              //  no duration → stays open
            }
          );
        }

      } else if (this.wasOffline) {
        // close offline snackbar
        if (this.offlineSnackRef) {
          this.offlineSnackRef.dismiss();
          this.offlineSnackRef = null;
        }

        // show back online message
        this.snackBar.open('Back Online', 'OK', {
          duration: 3000,
          panelClass: ['snackbar-success'],
          verticalPosition: 'top',
          horizontalPosition: 'center',
        });
        this.wasOffline = false;
      }
    });

  }

  sendDummyEmail() {
    this.mailService.sendMail({
      email: ['gauravdahale@icloud.com','sumeetsinghani@gmail.com','jay.dahale@gmail.com'],
      subject: 'Test Email',
      body: '<h1>This is a test email</h1><p>Sent from Accesslife Angular App</p>'
    })
      .subscribe({
        next: (response) => {
          console.log('Email sent successfully:', response);
        },
        error: (error) => {
          console.error('Error sending email:', error);
        }
      });

  }

  ngOnInit(): void {


    // this.CopyData('ALCentres','devCentre')
    this.getIpAddress();
    this.initializeUserData();

    // Ensure app responds to Firebase auth state changes: if user becomes null, clear local storage and navigate to login.
    this.mAuth.authState.pipe(takeUntil(this._destroyed$)).subscribe(async (user) => {
      if (!user) {
        const localUid = localStorage.getItem('uid');
        // If a uid was present locally, call SignOut() to run existing sign-out flow (logs, cleanup), otherwise just clear and navigate.
        if (localUid) {
          try {
            await this.mAuthService.SignOut();
          } catch (e) {
            // fallback: ensure local cleanup
            localStorage.clear();
            this.router.navigateByUrl('login');
          }
        } else {
          localStorage.clear();
          this.router.navigateByUrl('login');
        }
      }
    });

    // this.addGenderToIndividualCounselling()
    // this.setSponsorshipStatus();
    // this.bulkState('Maharshtra','Maharashtra')
    // this.bulkCenterChange('AL Gurunanak','AL Gurunanak Niwas')
    // this.addGenderToIn dividualCounselling()
    // this.replaceInterventionToArray()
    // this.shiftDonorstoALDonors()
    // this.setBulkAge()
    //    this.setBulkAge()
    //      this.addGenderToIndividualCounselling()
// this.bulkUploadEducationReview()
  }

  bulkUploadEducationReview() {
    let tDate = new Date()
    tDate.setDate(31)
    tDate.setMonth(4)
    tDate.setFullYear(2023)
    this.mFirestore.collection(this.env.education, ref => ref.where('sessionDate', '<=', tDate)).get().pipe(takeUntil(this._destroyed$)).subscribe(res => {
      res.docs.forEach(doc => {

        this.mFirestore.collection(this.env.education).doc(doc.id).update({
          reviewedBy: 'Dwani Gujral',
          status: 'Verified',
          reviewRemark: 'Bulk Verification from Database'
        }).then(r => {
          console.log(`EDUCATION GROUP SESSION UPDATED ${doc.id}`)
        })
      })
    })
  }

  setUnitsBulk(childArray: string[]) {
    childArray.forEach(it => {
      this.mFirestore.collection<FullChild>(this.env.child).doc(it).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe(child => {
        console.log(it, child?.childCode)
        this.mFirestore.doc(`${this.env.units}/${child?.centreCode}/units/${child?.selectUnit}`).update(
          {
            allotedTo: child?.childCode,
            centreCode: child?.centreCode,
            name: child?.firstName + ' ' + child?.lastName,
            status: 'Alloted'
          }
        ).then(() => {
          console.log('Updated', 'alloted' + child?.selectUnit)
        })
      })

    })

  }

  getCalculatedAge(child: firebase.firestore.Timestamp, childCode: string) {
    let timeDiff = Math.abs(Date.now() - (child).toDate().getTime());
    let age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
    // * UPDATING AGE IN FIRESTORE ALCHILD
    this.mFirestore.collection(this.env.child).doc(childCode).update({age: age}).then(() => {
      console.log(`SET DATE TO ${childCode} as`, age)
    })
      .catch(() => {
        console.log('ERROR ADDING AGE IN', childCode)
      })
    console.log(age)
    return age
  }

  setBulkAge() {
    this.mFirestore.collection<FullChild>(this.env.child).get().pipe(takeUntil(this._destroyed$)).subscribe(res => {
      alert(res.docs.length)

      res.forEach(it => {
          let c = it.data()
          console.log(c.dob)
          if (c.dob) this.getCalculatedAge(c.dob, c.childCode)
          else console.log('DOB NOT AVAILABLE IN ', c.childCode)
        }
      )
    })
  }


  private setupRouterEvents(): void {
    this.router.events.pipe(takeUntil(this._destroyed$)).subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf('/') + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
        // Add any additional logic for NavigationEnd events here.
      }
      window.scrollTo(0, 0);
    });
  }

  private getIpAddress(): void {
    this.ipService.getIpAddress().subscribe((response: any) => {
      this.ipAddress = response.ip;
      localStorage.setItem('currentip', this.ipAddress);
    });
  }

  private initializeUserData(): void {
    // Keyed off the Firebase session rather than the cached uid: on a reload the
    // session is restored before localStorage is refilled, and the old check read a
    // uid that may not have been written yet. Sending the user to login is left to
    // AuthGuard and the authState watcher above.
    this.mAuth.authState.pipe(
      filter((user): user is firebase.User => !!user),
      switchMap(user => this.mAuthService.watchUserData(user)),
      takeUntil(this._destroyed$)
    ).subscribe();
  }

  private addGenderToIndividualCounselling() {
    this.mFirestore.collection(`${this.env.counseling}/allSessions/sessions`).get().pipe(takeUntil(this._destroyed$)).subscribe(res => {
      let sessions = res.docs.map(doc => {
        // @ts-ignore
        return {id: doc.id, ...doc.data()};
      });
      let nullsessions = sessions.filter(x => x.state == null || x.state == '')
      console.log()
      console.log(sessions); // or do whatever you need with the sessions array
      nullsessions.forEach(it => {
        this.mFirestore.collection<FullChild>(this.env.child).doc(it.childCode).get().pipe(takeUntil(this._destroyed$)).subscribe(res => {
          let childData = res.data()

          this.mFirestore.collection(`${this.env.counseling}/allSessions/sessions`).doc(it.id).update({state: childData?.state}).then(res => {
              console.log('Updated in record', it.id)
            }
          )
        })
      })
    });
  }

  private bulkState(maharshtra: string, maharashtra: string) {
    this.mFirestore.collection<FullChild>(this.env.child, ref => ref.where('state', '==', 'Gujrat ')).get().pipe(takeUntil(this._destroyed$)).subscribe(res => {
      let mData = res.docs.map(y => y.data())
      alert(mData.length)
      mData.forEach(it => {
        this.mFirestore.collection(this.env.child).doc(it.childCode).update({'state': 'Gujarat'}).then(res => {
          console.log('Updated state in ' + it.childCode)
        })
      })
    })
  }

  private bulkCenterChange(field1: string, field2: string) {
    this.mFirestore.collection<FullChild>(this.env.child, ref => ref.where('centreName', '==', field1)).get().pipe(takeUntil(this._destroyed$)).subscribe(res => {
      let mData = res.docs.map(y => y.data())
      alert(mData.length)
      mData.forEach(it => {
        this.mFirestore.collection(this.env.child).doc(it.childCode).update({'centreName': field2}).then(res => {
          console.log('Updated cetnreNames in ' + it.childCode)
        })
      })
    })
  }


  private CopyData(alChild: string, devChild: string) {
    this.mFirestore.collection<Centre>(alChild).get().pipe(takeUntil(this._destroyed$)).subscribe(res => {
      res.docs.forEach(it => {
        let child = it.data()
        this.mFirestore.collection(devChild).doc(it.data()!!.centreCode).set(child)
          .then(res => {
            console.log('Added Child with child code', child.centreCode)
          })
      })
    })
  }

  private replaceInterventionToArray() {
    this.mFirestore.collection<any>(`${this.env.counseling}/allSessions/sessions`).get().pipe(takeUntil(this._destroyed$)).subscribe(querySnapshot => {
      querySnapshot.forEach(doc => {
        // Extract the value of the "interventions" field
        const interventionString: string = doc.data().interventions || '';

        // Check if interventions field is not null, empty, or undefined
        if (interventionString) {
          // Update the document with interventions array
          this.mFirestore.collection(`${this.env.counseling}/allSessions/sessions`).doc(doc.id).update(
            {interventions: firebase.firestore.FieldValue.arrayUnion(interventionString.toString())}
          ).then(() => {
            console.log('Updated interventions in ' + doc.id);
          }).catch(error => {
            console.error('Error updating interventions:', error);
          });
        }
      });
    });
  }

  private shiftDonorstoALDonors() {
    this.mFirestore.collection(this.env.donors).get()
      .pipe(
        map(x => x.docs.map(y => y.data() as Donor)),
        takeUntil(this._destroyed$)
      ).subscribe(res => {
      res.forEach(it => {
        this.mFirestore.collection(this.env.donors).doc(it.pan!!).set(it).then(res => {
          console.log('Donor addded', it.pan)
        })

      })
    })
  }

//     setSponsorshipStatus() {
//
//         this.mFirestore.collection<FullChild>('ALChild')
//             .valueChanges()
//             .subscribe(child => {
//
//                 let children = child.filter(x=> x.sponsored ==undefined)
//                 alert('set sponsorship status'+children.length)
// children.forEach(it=>{
//     // console.log('TOTAL UNSPONSORED CHILDREN',child.docs.length)
// //     this.mFirestore.collection('ALChild').doc(it.childCode).update({sponsored: false}).then(res => {
// //     console.log('added sponsored status to '+it.id)
// // })
//             })
//             })
//     }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}

function onCopy(event: globalThis.Event | undefined, ClipboardEvent: {
  new(type: string, eventInitDict?: ClipboardEventInit | undefined): ClipboardEvent;
  prototype: ClipboardEvent;
}) {
  throw new Error('Function not implemented.');
}
